import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { RootState } from "slices";
import logoLight from "assets/images/logo-light.png";
import logoDark from "assets/images/logo-dark.png";
import { Link, useNavigate } from "react-router-dom";
import { verifyOTP } from "slices/thunk";
import { createSelector } from "reselect";
import { ToastContainer } from "react-toastify";
import { Loader2 } from "lucide-react";

const VerifyOTP = () => {
    document.title = "Verify OTP | Tailwick - React Admin & Dashboard Template";
    const dispatch = useDispatch<any>();
    const navigate = useNavigate();

    const email = useSelector((state: RootState) => state.ForgotPassword.email);


    const selectVerifyOtp = createSelector(
        (state: RootState) => state.verifyOtp,
        (verifyOtp) => ({
            success: verifyOtp.isVerified,
            error: verifyOtp.verifyError,
            isLoading: verifyOtp.isLoading,
        })
    );

    const { success, error, isLoading } = useSelector(selectVerifyOtp);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            otp: "",
        },
        validationSchema: Yup.object({
            otp: Yup.number()
                .required("OTP is required")
                .test("len", "OTP must be 6 digits", (val) => val?.toString().length === 6),
        }),
        onSubmit: (values: any) => {
            if (email) {
                dispatch(verifyOTP({ email, otp: String(values.otp) }, navigate));
            } else {
                navigate("/forgot-password");
            }
        },
    });

    React.useEffect(() => {
        const bodyElement = document.body;

        bodyElement.classList.add(
            "flex",
            "items-center",
            "justify-center",
            "min-h-screen",
            "py-16",
            "lg:py-10",
            "bg-slate-50",
            "dark:bg-zink-800",
            "dark:text-zink-100",
            "font-public"
        );

        return () => {
            bodyElement.classList.remove(
                "flex",
                "items-center",
                "justify-center",
                "min-h-screen",
                "py-16",
                "lg:py-10",
                "bg-slate-50",
                "dark:bg-zink-800",
                "dark:text-zink-100",
                "font-public"
            );
        };
    }, []);

    return (
        <React.Fragment>
            <ToastContainer closeButton={false} limit={1} />
            <div className="relative">
                {/* <AuthIcon /> */}

                <div className="mb-0 w-screen lg:w-[500px] card shadow-lg border-none shadow-slate-100 relative">
                    <div className="!px-10 !py-12 card-body">
                        <Link to="/">
                            <img
                                src={logoLight}
                                alt=""
                                className="hidden h-6 mx-auto dark:block"
                            />
                            <img
                                src={logoDark}
                                alt=""
                                className="block h-6 mx-auto dark:hidden"
                            />
                        </Link>

                        <div className="mt-8 text-center">
                            <h4 className="mb-1 text-custom-500 dark:text-custom-500">
                                OTP Verification
                            </h4>
                            <p className="text-slate-500 dark:text-zink-200">
                                Verify your account by entering the OTP sent to your registered email.
                            </p>
                        </div>

                        <form
                            className="mt-10"
                            id="verifyOtpForm"
                            onSubmit={formik.handleSubmit}
                        >

                            {success && (
                                <div
                                    className="px-4 py-3 mb-3 text-sm text-green-500 border border-green-200 rounded-md bg-green-50 dark:bg-green-400/20 dark:border-green-500/50"
                                >
                                    Your OTP has been successfully verified.
                                </div>
                            )}
                            {error && (
                                <div
                                    className="px-4 py-3 mb-3 text-sm text-red-500 border border-red-200 rounded-md bg-red-50 dark:bg-red-400/20 dark:border-red-500/50"
                                >
                                    Invalid OTP. Please check the code and try again.
                                </div>
                            )}

                            <div className="mb-3">
                                <label
                                    htmlFor="email-field"
                                    className="inline-block mb-2 text-base font-medium"
                                >
                                    Verification Code
                                </label>
                                {/* <div className="flex justify-between gap-2">
                                    {[...Array(6)].map((_, index) => (
                                        <input
                                            key={index}
                                            type="text"
                                            maxLength={1}
                                            name={`otp-${index}`}
                                            className="w-12 h-12 text-center border-b-2 border-gray-300 focus:outline-none focus:border-custom-500 text-lg"
                                            onChange={(e) => {
                                                const input = e.target as HTMLInputElement;
                                                const value = input.value;
                                                if (/^\d$/.test(value)) {
                                                    formik.setFieldValue(
                                                        "otp",
                                                        (formik.values.otp ?? "").substring(0, index) +
                                                        value +
                                                        (formik.values.otp ?? "").substring(index + 1)
                                                    );
                                                    const nextInput = input.nextElementSibling as HTMLInputElement | null;
                                                    if (nextInput) {
                                                        nextInput.focus();
                                                    } else {
                                                        input.value = "";
                                                    }
                                                }
                                            }}
                                            onKeyDown={(e) => {
                                                const input = e.target as HTMLInputElement;
                                                if (e.key === "Backspace" && !input.value) {
                                                    const prevInput = input.previousElementSibling as HTMLInputElement | null;
                                                    if (prevInput) {
                                                        prevInput.focus();
                                                    }
                                                }
                                            }}
                                            onPaste={(e) => {
                                                e.preventDefault();
                                                const input = e.target as HTMLInputElement;
                                                const clipboardData = e.clipboardData?.getData("Text") || "";
                                                if (/^\d{6}$/.test(clipboardData)) {
                                                    clipboardData.split("").forEach((char, i) => {
                                                        const field = document.querySelector(
                                                            `input[name="otp-${i}"]`
                                                        ) as HTMLInputElement | null;
                                                        if (field) {
                                                            field.value = char;
                                                        }
                                                    });
                                                    formik.setFieldValue("otp", clipboardData);
                                                }
                                            }}
                                        />
                                    ))}
                                </div> */}

                                <input
                                    type="text"
                                    id="verify-otp-field"
                                    name="otp"
                                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                    placeholder="Enter OTP"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                                {formik.touched.otp && formik.errors.otp ? (
                                    <div id="otp-error" className="mt-1 text-sm text-red-500">
                                        {String(formik.errors.otp)}
                                    </div>
                                ) : null}
                            </div>
                            <div className="mt-10 flex justify-center">
                                {isLoading ? (
                                    <button type="button" className="flex items-center text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">
                                    <Loader2 className="w-full size-4 ltr:mr-2 rtl:ml-2 animate-spin" />
                                    Verifying...
                                </button>
                                ) : (
                                <button
                                    type="submit"
                                    className="w-full text-white transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                                    disabled={isLoading}
                                >
                                    Verify OTP
                                </button>
                                )}
                            </div>

                            <div className="mt-10 text-center">
                                <p className="mb-0 text-slate-500 dark:text-zink-200">
                                    <Link
                                        to="/login"
                                        className="font-semibold transition-all duration-150 ease-linear text-slate-500 dark:text-zink-200 hover:text-custom-500 dark:hover:text-custom-500"
                                    >
                                        Back to login
                                    </Link>{" "}
                                </p>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default VerifyOTP;


